import Image from "next/image";
import { PureComponent } from "react";

import { translationsContent } from "../../localization/translations";
import imageLoader from "../../utils/loader";
import classes from "./stripe-redirect-page-iframe.module.scss";

export class StripeRedirect extends PureComponent<
  unknown,
  { message: string }
> {
  constructor(props: unknown) {
    super(props);
    this.state = {
      message: translationsContent.stripeRedirectIframeLoader.fr,
    };
  }

  componentDidMount() {
    if (window !== undefined) {
      const language = localStorage.getItem("language");
      if (
        language === "fr" ||
        language === "en" ||
        language === "es" ||
        language === "nl"
      )
        this.setState({
          message: translationsContent.stripeRedirectIframeLoader[language],
        });
    }
  }

  render() {
    return (
      <div className={classes.redirectContainer}>
        <div className={classes.redirectMessage}>
          <p>{this.state.message}</p>
          <div className={classes.loaderContainer}>
            <Image
              loader={imageLoader}
              src="loader.png"
              alt="Loader"
              height={140}
              width={140}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default StripeRedirect;
